import script from "./SearchInputResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchInputResult.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"SearchInputResult.vue"]])

export default __exports__